import { array, func, object, string } from 'prop-types';
import React from 'react';
import { Accordion } from 'react-bootstrap';
const AccordionCollapse = props => {
    AccordionCollapse.propTypes = {
        activeClause: object,
        classificationName: string,
        clauses: array,
        setActiveClause: func,
    };
    const { activeClause, classificationName, clauses, setActiveClause, } = props;
    return (React.createElement(Accordion.Collapse, { eventKey: classificationName, style: { height: 'auto' } },
        React.createElement("div", { className: 'collapse-clauses' }, clauses === null || clauses === void 0 ? void 0 : clauses.map((clause, index) => {
            var _a, _b;
            const isSelected = clause.id === (activeClause === null || activeClause === void 0 ? void 0 : activeClause.id);
            const pageNum = (_b = (_a = clause.regions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.pageNum;
            return (React.createElement("div", { className: 'collapse-clauses-container', key: index, onClick: () => setActiveClause(clause) },
                React.createElement("span", { className: `collapse-clause ${isSelected ? 'selected' : ''}` }, clause.primaryClassification.displayName),
                pageNum &&
                    React.createElement("span", { className: 'page-num' }, ` (p. ${pageNum})`)));
        }))));
};
export default AccordionCollapse;
